module.exports = __webpack_public_path__ + "static/media/firemen_back.b9dae796.png";